module.exports = __webpack_public_path__ + "img/pic_subject_english.bda2795c.png";